/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */

import { AssetsConfigModalWithWrappers } from './AssetsConfigModalWithWrappers';

export const ASSETS_LIST_OF_LINKS_DATASOURCE_ID = '361d618a-3c04-40ad-9b27-3c8ea6927020';

export default AssetsConfigModalWithWrappers;

/**
 * @deprecated Use `import { AssetsConfigModalWithWrappers } from '@atlaskit/link-datasource/assets-config-modal-with-wrappers'` instead.
 */
export { AssetsConfigModalWithWrappers } from './AssetsConfigModalWithWrappers';
/**
 * @deprecated Use `import { AssetsConfigModalWithWrappers } from '@atlaskit/link-datasource/assets-config-modal-with-wrappers'` instead.
 */
export { AssetsConfigModalWithWrappers as AssetsConfigModal } from './AssetsConfigModalWithWrappers';
